// extracted by mini-css-extract-plugin
export default {"aboutMeContainer":"AboutMe_aboutMeContainer__wtLCU","content":"AboutMe_content__+c7Mi","image":"AboutMe_image__PiLyQ","linkText":"AboutMe_linkText__DsQvi"};